import { ArrowLeft, Pencil, Trash2 } from "lucide-react";
import { formatDate, renderBody, tagClass } from "@/components/decodes/format";

export default function DecodeView({ decode, admin, onBack, onEdit, onDelete }) {
  return (
    <article className="space-y-5 max-w-4xl mx-auto">
      <button
        onClick={onBack}
        className="font-mono text-xs muted hover:text-white flex items-center gap-2"
        data-testid="back-to-decodes"
      >
        <ArrowLeft size={14} /> back to decodes
      </button>
      <header className="space-y-3">
        <div className="font-mono text-[10px] uppercase tracking-[0.22em] muted">
          {formatDate(decode.created_at)} · by {decode.author}
        </div>
        <h1 className="font-display text-3xl md:text-5xl tracking-tight leading-tight">
          {decode.title}
        </h1>
        {decode.tags && decode.tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5">
            {decode.tags.map((t) => <span key={t} className={tagClass(t)}>{t}</span>)}
          </div>
        )}
      </header>
      <div className="panel p-6 md:p-8 text-base md:text-lg font-mono space-y-1">
        {renderBody(decode.body)}
      </div>
      {admin && (
        <div className="flex gap-3">
          <button
            onClick={onEdit}
            className="btn-secondary px-4 py-2 text-xs flex items-center gap-2"
            data-testid="decode-edit"
          >
            <Pencil size={14} /> Edit
          </button>
          <button
            onClick={onDelete}
            className="btn-danger px-4 py-2 text-xs flex items-center gap-2"
            data-testid="decode-delete"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )}
    </article>
  );
}
